import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import "../FormCard/FormCard.css"

import iconArrowLeft from "../../assets/financial-breed-images/icon-arrow.png"
import iconArrowRight from "../../assets/financial-breed-images/icon-arrow-r.png"
import yesIcon from "../../assets/financial-breed-images/icon-yes.png"
import NoIcon from "../../assets/financial-breed-images/icon-no.png"
import IconMayBe from "../../assets/financial-breed-images/icon-maybe.png"
import IconCalBefore from "../../assets/financial-breed-images/icon-cal-before.png"
import IconCalAfter from "../../assets/financial-breed-images/icon-cal-after.png"
import lockImg from "../../assets/lock-icon-sm.png"

import * as EmailValidator from 'email-validator';
import ERRORMSG from "../ErrToolTip/errorToolTip";

// Phone Country Code
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

// Firebase
import { addDoc, collection, serverTimestamp, doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

// Email
import sendEmail from "../../email"


let data = [{
    // ------------------------
}, {
    // 1
    q: "I had W2 employees in 2020 or 2021",
    answer: "",
    options: ["yes", "no"],
    type: "button"
}, {
    // 2
    q: "Roughly, how many Full Time W2 Employees did you have on average during 2020?",
    answer: "",
    options: [1, 500],
    type: "numberRange"
}, {
    // 3
    q: "Did you start your business before or after Feb 15, 2020?",
    answer: "",
    options: ["I Started Before Feb 15, 2020", "I Started After Feb 15, 2020"],
    type: "button"
}, {
    // 4
    q: "Did you get a PPP loan in 2020 or 2021?",
    answer: "",
    options: ["Yes, I Got a PPP Loan", "No, I Did Not..."],
    type: "button"
}, {
    // 5
    q: "Did you have a decrease in revenue of at least 50% in any quarter in 2020 compared to 2019?",
    answer: "",
    options: ["Yes, We Had a +50% Decrease", "No, I Did Not..."],
    type: "button"
}, {
    // 6
    q: "Did you have a decrease in revenue of at least 20% in any quarter in 2021 compared to 2019?",
    answer: "",
    options: ["Yes, We Had a +20% Decrease", "No, I Did Not..."],
    type: "button"
}, {
    // 7
    q: "Did you experience any partial or full suspensions of business due to a COVID Government Order in 2020 or 2021?",
    answer: "",
    options: ["Yes, in Both Years", "Yes, But only in 2020", "Yes, But only in 2021", "No..."],
    type: "button"
}, {
    // 8
    q: "Did you experience a supply chain disruption in 2021?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 9
    q: "Did you experience a supply chain disruption in 2020",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 10
    q: "Did you experience any partial or full suspensions of business due to a COVID Government Order in 2021?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 11
    q: "Did you experience a supply chain disruption in 2021?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 12
    q: "Did you experience any partial or full suspensions of business due to a COVID Government Order in 2020?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 13
    q: "Did you experience a supply chain disruption in 2020?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 14
    q: "Did your business generate over $1 million in gross revenue in 2020?",
    answer: "",
    options: ["Yes, It Earned Over $1 Million", "No, I Did Not..."],
    type: "button"
}, {
    // 15
    q: "Did you get a PPP loan in 2020 or 2021?",
    answer: "",
    options: ["Yes, I Got a PPP Loan", "No, I Did Not..."],
    type: "button"
}, {
    // 16
    q: "Did you have a decrease in revenue of at least 20% in any quarter in 2021 compared to 2019?",
    answer: "",
    options: ["Yes, We Had a +20% Decrease", "No, I Did Not..."],
    type: "button"
}, {
    // 17
    q: "Did you experience any partial or full suspensions of business due to a COVID Government Order in 2020 or 2021?",
    answer: "",
    options: ["Yes, in Both Years", "Yes, But only in 2020", "Yes, But only in 2021", "No..."],
    type: "button"
}, {
    // 18
    q: "Did you experience a supply chain disruption in 2021?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 19
    q: "Did you experience a supply chain disruption in 2020",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 20
    q: "Did you experience any partial or full suspensions of business due to a COVID Government Order in 2020 or 2021?",
    answer: "",
    options: ["Yes, in Both Years", "Yes, But only in 2020", "Yes, But only in 2021", "..."],
    type: "button"
}, {
    // 21
    q: "Did you experience a supply chain disruption in 2021?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 22
    q: "Did you experience any partial or full suspensions of business due to a COVID Government Order in 2020?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 23
    q: "Did you experience a supply chain disruption in 2021?",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}, {
    // 24
    q: "Did you experience a supply chain disruption in 2020",
    answer: "",
    options: ["Yes, I Did", "No..."],
    type: "button"
}]

// "Calculating Results"
// "You Do Not Qualify for ERC"



function FormCard() {
    const navigate = useNavigate()
    const [Q, setQ] = useState(1)
    const [Data, setData] = useState(data)
    const [Options, setOptions] = useState([])
    const [Answers, setAnswers] = useState([])
    const [Progress, setProgress] = useState(7.14);

    const [temp1, setTemp1] = useState("")
    const [yes, setYes] = useState(false)

    function handleOnClick(index, ans) {
        let NewProg = parseFloat(Progress) + 7.14
        setProgress(NewProg)

        if (index === 1) {
            let temp = data;
            temp[index].answer = ans;
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (index === 2) {
            let temp = data;
            temp[index].answer = temp1;
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (index === 3 && ans === "before") {
            let temp = data;
            temp[index].answer = Data[3].options[0];
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (index === 3 && ans === "after") {
            let temp = data;
            temp[index].answer = Data[3].options[1];
            data = temp;
            setAnswers(temp);
            setQ(index + 11);

        } else if (index === 4) {
            let temp = data;
            temp[index].answer = Data[4].options[0];
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (index === 5) {
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[5].options[0] : Data[5].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (index === 6) {
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[6].options[0] : Data[6].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (Q === 7 && Data[5].answer === Data[5].options[0] && Data[6].answer === Data[6].options[0]) {
            // alert("calculating result")
            // calculateResult()
            // let temp = data;
            // temp[index].answer = (ans === "yes" ? Data[6].options[0] : Data[6].options[1]);
            // data = temp;
            // setAnswers(temp);
            // setQ(index + 1);

        } else if (Q === 7 && Data[5].answer === Data[5].options[1] && Data[6].answer === Data[6].options[1]) {
            // alert("calculating result")
            let temp = data;
            temp[7].answer = (ans === "yes" ? Data[7].options[0] : ans === "2020" ? Data[7].options[1] : ans === "2021" ? Data[7].options[2] : Data[7].options[3]);
            data = temp;
            setAnswers(temp);
            setQ(7 + 1);

        } else if (Q === 8 && Data[7].answer === Data[7].options[0]) {
            // alert("calculating result")
            // calculateResult()

        } else if (Q === 8 && Data[7].answer === Data[7].options[1]) {
            // alert("calculating result")
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[11].options[0] : Data[11].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(8 + 1);

        } else if ((Q === 9 && index === 11 && (Data[11].answer === Data[11].options[0] || Data[11].answer === Data[11].options[1]))) {
            // alert("calculating result")
            // calculateResult()

        } else if ((index === 9 && (Data[7].answer === Data[7].options[2]))) {
            // alert("calculating result")
            // calculateResult()
            // let temp = data;
            // temp[index].answer = (ans === "yes" ? Data[11].options[0] : Data[11].options[1]);
            // data = temp;
            // setAnswers(temp);
            setQ(8 + 1);

        } else if ((index === 12 && Data[5].answer === Data[5].options[1] && Data[6].answer === Data[6].options[0])) {
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[12].options[0] : Data[12].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(8 + 1);

        } else if (index === 12 && Data[12].answer === Data[12].options[0]) {
            // alert("Calculating result")
            // calculateResult()

        } else if ((index === 10 && Data[5].answer === Data[5].options[0] && Data[6].answer === Data[6].options[1])) {
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[10].options[0] : Data[10].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(10);

            // } else if(index === 10 && Data[10].answer === Data[12].options[0]) {
            //     alert("Calculating result")



            // } else if (index === 14 && ans === "yes") {
            //     let temp = data;
            //     temp[index].answer = Data[14].options[0];
            //     data = temp;
            //     setAnswers(temp);
            //     setQ(index + 1);

            // } else if (index === 14 && ans === "no") {
            //     let temp = data;
            //     temp[index].answer = Data[14].options[1];
            //     data = temp;
            //     setAnswers(temp);
            //     setQ(index + 1);

            // }
        }
        //mera----------------------------
        else if (index === 14 && ans === "yes") {
            let temp = data;
            temp[index].answer = Data[14].options[0];
            data = temp;
            setAnswers(temp);
            setQ(15);

        }
        else if (index === 14 && ans === "no") {
            let temp = data;
            temp[index].answer = Data[14].options[1];
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        }
        else if (index === 15) {
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[15].options[0] : Data[15].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (index === 16) {
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[16].options[0] : Data[16].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(index + 1);

        } else if (Q === 17 && Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[0]) {
            // alert("calculating result")
            // calculateResult()
            // let temp = data;
            // temp[index].answer = (ans === "yes" ? Data[6].options[0] : Data[6].options[1]);
            // data = temp;
            // setAnswers(temp);
            // setQ(index + 1);

        }
        else if ((Q === 17 && (Data[15].answer === Data[15].options[1] && Data[16].answer === Data[16].options[1] ||
            Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[1]))) {
            // alert("calculating result")
            let temp = data;
            temp[17].answer = (ans === "yes" ? Data[17].options[0] : ans === "2020" ? Data[17].options[1] : ans === "2021" ? Data[17].options[2] : Data[17].options[3]);
            data = temp;
            setAnswers(temp);
            setQ(18);

        }
        else if (Q === 18 && Data[17].answer === Data[17].options[0]) {
            // alert("calculating result")
            // calculateResult()

        } else if (Q === 18 && Data[17].answer === Data[17].options[1]) {
            // alert("calculating result")
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[11].options[0] : Data[11].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(9);
        }
        else if ((Q === 19 && index === 21 && (Data[21].answer === Data[21].options[0] || Data[21].answer === Data[21].options[1]))) {
            // alert("calculating result")
            // calculateResult()

        } else if ((index === 19 && (Data[17].answer === Data[17].options[2]))) {
            // alert("calculating result")
            // calculateResult()
            // let temp = data;
            // temp[index].answer = (ans === "yes" ? Data[11].options[0] : Data[11].options[1]);
            // data = temp;
            // setAnswers(temp);
            setQ(19);

        } else if ((index === 22 && Data[15].answer === Data[15].options[1] && Data[16].answer === Data[16].options[0])) {
            let temp = data;
            temp[index].answer = (ans === "yes" ? Data[12].options[0] : Data[12].options[1]);
            data = temp;
            setAnswers(temp);
            setQ(19);

        } else if (index === 22 && Data[22].answer === Data[22].options[0]) {
            // alert("Calculating result")
            // calculateResult()

            // } else if ((index === 20 && Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[1])) {
            //     let temp = data;
            //     temp[index].answer = (ans === "yes" ? Data[20].options[0] : Data[20].options[1]);
            //     data = temp;
            //     setAnswers(temp);
            //     setQ(20);
        }
        // else if ((index === 20 && Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[1])) {
        //     // alert("calculating result")
        //     let temp = data;
        //     temp[20].answer = (ans === "yes" ? Data[20].options[0] : ans === "2020" ? Data[20].options[1] : ans === "2021" ? Data[20].options[2] : Data[20].options[3]);
        //     data = temp;
        //     setAnswers(temp);
        //     setQ(23);

        // }
        //mera--------------------------

        // console.log(data, Q);
    }

    function calculateResult() {
        let amount = 1;

        // Before and Both Yes
        if (Data[5].answer === Data[5].options[0] && Data[6].answer === Data[6].options[0]) {
            amount = 26000;
        }

        // Before and Both No
        if (Data[5].answer === Data[5].options[1] && Data[6].answer === Data[6].options[1]) {
            if (Data[7].answer === Data[7].options[0]) {
                amount = 26000;

            } else if (Data[7].answer === Data[7].options[1]) {
                amount = 5000;

            } else if (Data[7].answer === Data[7].options[2]) {
                amount = 21000;

            } else {
                amount = 0;

            }
        }

        // Before and Yes and No
        if (Data[5].answer === Data[5].options[0] && Data[6].answer === Data[6].options[1]) {
            if (Data[10].answer === Data[10].options[0]) {
                amount = 26000;

            } else if (Data[10].answer === Data[10].options[1]) {
                amount = 5000;

            } else {
                amount = 0;

            }
        }

        // Before and No and Yes
        if (Data[5].answer === Data[5].options[1] && Data[6].answer === Data[6].options[0]) {
            if (Data[12].answer === Data[12].options[0]) {
                amount = 26000;

            } else if (Data[12].answer === Data[12].options[1]) {
                amount = 21000;

            } else {
                amount = 0;

            }
        }
        //After Both yes
        if (Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[0]) {
            amount = 26000;
        }


        // After and No and Yes
        if (Data[15].answer === Data[15].options[1] && Data[16].answer === Data[16].options[0]) {
            if (Data[22].answer === Data[22].options[0]) {
                amount = 26000;

            } else if (Data[22].answer === Data[22].options[1]) {
                amount = 21000;

            } else {
                amount = 0;

            }
        }

        // After Yes and No
        if (Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[1]) {
            if (Data[17].answer === Data[17].options[0]) {
                amount = 26000;

            } else if (Data[17].answer === Data[17].options[1]) {
                amount = 5000;

            } else if (Data[17].answer === Data[17].options[2]) {
                amount = 21000;

            } else {
                amount = 0;

            }
        }

        // After Both No
        if (Data[15].answer === Data[15].options[1] && Data[16].answer === Data[16].options[1]) {
            if (Data[17].answer === Data[17].options[0]) {
                amount = 26000;

            } else if (Data[17].answer === Data[17].options[1]) {
                amount = 5000;

            } else if (Data[17].answer === Data[17].options[2]) {
                amount = 21000;

            } else {
                amount = 0;

            }
        }

        const Total = amount * parseInt(Data[2].answer)
        localStorage.setItem("amount", Total)

        navigate(`/result?name=${localStorage.getItem("name")}&amount=${Total}`)

    }

    function SaveNumber(event) {
        setTemp1(event.target.value)
    }

    function Pre(i, v, ques) {
        let New = Data
        New[i].answer = ""
        setData(New)
        if (typeof ques !== "undefined" && ques !== null && ques !== "") {
            // alert("PREVIOUS")
            setQ(ques)
        }
    }

    function Valid() {
        if (temp1 !== 0 && temp1 !== "") {
            handleOnClick(2)
        } else {
            setYes(true)
        }
    }

    return (
        <>
            <div className="formCard">
                <div className="progress">
                    <div className="progress-bar" style={{ width: `${Progress}%`, backgroundColor: "rgb(39, 159, 150)", borderRadius: "10px 0px 0px" }} role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" ></div>
                </div>

                {
                    Q === 1 ? <>
                        <h2>I had W2 employees in 2020 or 2021</h2>
                        <div className="panel-body">
                            <div className="panel-content">
                                <img src={iconArrowLeft} alt="" className='img-fluid iconLeft' />
                                <em>Please select one</em>
                                <img src={iconArrowRight} alt="" className='img-fluid iconRight' />
                            </div>
                        </div>

                        <div className="parentDiv">
                            <div className="yesAnswer mb-4">
                                <div className="iconDiv">
                                    <img src={yesIcon} alt="" className='img-fluid' />
                                </div>
                                <div className="questionDiv" onClick={() => handleOnClick(1, "yes")}>
                                    <span>Yes</span>
                                </div>
                            </div>
                            <div className="yesAnswer">
                                <div className="iconDiv">
                                    <img src={NoIcon} alt="" className='img-fluid' />
                                </div>
                                <div className="questionDiv" onClick={() => handleOnClick(1, "no")}>
                                    <span>No</span>
                                </div>
                            </div>

                        </div>

                    </>
                        :
                        Q === 2 && Data[1].answer === "yes" ? <>
                            <div className="secondPage p-4">
                                <h2>Roughly, how many Full Time W2 Employees did you have on average during 2020?</h2>
                                <form style={{ position: "relative" }}>
                                    <input type="number" value={temp1} min={1} minLength={1} className="form-control mb-3 p-3" placeholder='20' onChange={(e) => SaveNumber(e)} />
                                    {yes && <ERRORMSG msg={"Invalid number"} />}
                                </form>
                                <div className="row formBTNs">
                                    <div className="col-3 backBtn">
                                        <a href="#" className='btn' onClick={() => Pre(1, "", 1)}>←</a>
                                    </div>
                                    <div className="col-9 contBtn">
                                        <a href="#" className='btn' onClick={() => Valid()}>Continue →</a>
                                    </div>
                                </div>
                            </div>
                        </>
                            :
                            Q === 3 ?
                                <div className="thirdPage">
                                    <h2>{Data[3].q}</h2>
                                    <div className="parentDiv">
                                        <div className="yesAnswer mb-4">
                                            <div className="iconDiv">
                                                <img src={IconCalBefore} alt="" className='img-fluid' />
                                            </div>
                                            <div className="questionDiv" onClick={() => (handleOnClick(3, "before"))}>
                                                <span>{Data[3].options[0]}</span>
                                            </div>
                                        </div>
                                        <div className="yesAnswer">
                                            <div className="iconDiv">
                                                <img src={IconCalAfter} alt="" className='img-fluid' />
                                            </div>
                                            <div className="questionDiv" onClick={() => (handleOnClick(3, "after"))}>
                                                <span>{Data[3].options[1]}</span>
                                            </div>
                                        </div>
                                        <div className="backBtn mt-4">
                                            <a href="#" className='btn' onClick={() => Pre(2, "", 2)}>←</a>
                                        </div>
                                        {/* <div className="contBtn">
                                        <a href="#" className='btn'>Continue →</a>
                                    </div> */}
                                    </div>
                                </div>
                                :
                                Q === 4 ? <>
                                    <h2>{Data[4].q}</h2>
                                    <div className="parentDiv">
                                        <div className="yesAnswer mb-4">
                                            <div className="iconDiv">
                                                <img src={yesIcon} alt="" className='img-fluid' />
                                            </div>
                                            <div className="questionDiv" onClick={() => handleOnClick(4, "yes")}>
                                                <span>{Data[4].options[0]}</span>
                                            </div>
                                        </div>
                                        <div className="yesAnswer">
                                            <div className="iconDiv">
                                                <img src={NoIcon} alt="" className='img-fluid' />
                                            </div>
                                            <div className="questionDiv" onClick={() => handleOnClick(4, "no")}>
                                                <span>{Data[4].options[1]}</span>
                                            </div>
                                        </div>
                                        <div className="backBtn mt-4">
                                            <a href="#" className='btn' onClick={() => Pre(3, "", 3)}>←</a>
                                        </div>
                                        {/* <div className="contBtn mt-4">
                                            <a href="#" className='btn'>Continue →</a>
                                        </div> */}
                                    </div>

                                </>
                                    :
                                    Q === 5 ? <>
                                        <h2>{Data[5].q}</h2>
                                        <div className="parentDiv">
                                            <div className="yesAnswer mb-4">
                                                <div className="iconDiv">
                                                    <img src={yesIcon} alt="" className='img-fluid' />
                                                </div>
                                                <div className="questionDiv" onClick={() => handleOnClick(5, "yes")}>
                                                    <span>{Data[5].options[0]}</span>
                                                </div>
                                            </div>
                                            <div className="yesAnswer">
                                                <div className="iconDiv">
                                                    <img src={NoIcon} alt="" className='img-fluid' />
                                                </div>
                                                <div className="questionDiv" onClick={() => handleOnClick(5, "no")}>
                                                    <span>{Data[5].options[1]}</span>
                                                </div>
                                            </div>
                                            <div className="backBtn mt-4">
                                                <a href="#" className='btn' onClick={() => Pre(4, "", 4)}>←</a>
                                            </div>
                                            {/* <div className="contBtn mt-4">
                                            <a href="#" className='btn'>Continue →</a>
                                        </div> */}
                                        </div>
                                    </>
                                        :
                                        Q === 6 ? <>
                                            <h2>{Data[6].q}</h2>
                                            <div className="parentDiv">
                                                <div className="yesAnswer mb-4">
                                                    <div className="iconDiv">
                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                    </div>
                                                    <div className="questionDiv" onClick={() => handleOnClick(6, "yes")}>
                                                        <span>{Data[6].options[0]}</span>
                                                    </div>
                                                </div>
                                                <div className="yesAnswer">
                                                    <div className="iconDiv">
                                                        <img src={NoIcon} alt="" className='img-fluid' />
                                                    </div>
                                                    <div className="questionDiv" onClick={() => handleOnClick(6, "no")}>
                                                        <span>{Data[6].options[1]}</span>
                                                    </div>
                                                </div>
                                                <div className="backBtn mt-4">
                                                    <a href="#" className='btn' onClick={() => Pre(5, "", 5)}>←</a>
                                                </div>
                                            </div>

                                        </>
                                            :
                                            //  Means Boths Yes
                                            Q === 7 && Data[5].answer === Data[5].options[0] && Data[6].answer === Data[6].options[0] ?
                                                <div className="secondPage p-4">
                                                    {/* <h2>Calculation result</h2> */}
                                                    < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                    {/* {calculateResult()} */}
                                                </div>
                                                :
                                                //  Means Boths No
                                                Q === 7 && Data[5].answer === Data[5].options[1] && Data[6].answer === Data[6].options[1] ?
                                                    <>
                                                        <h2>{Data[7].q}</h2>
                                                        <div className="parentDiv">
                                                            <div className="yesAnswer mb-4">
                                                                <div className="iconDiv">
                                                                    <img src={yesIcon} alt="" className='img-fluid' />
                                                                </div>
                                                                <div className="questionDiv" onClick={() => handleOnClick(7, "yes")}>
                                                                    <span>{Data[7].options[0]}</span>
                                                                </div>
                                                            </div>
                                                            <div className="yesAnswer mb-4">
                                                                <div className="iconDiv">
                                                                    <img src={yesIcon} alt="" className='img-fluid' />
                                                                </div>
                                                                <div className="questionDiv" onClick={() => handleOnClick(7, "2020")}>
                                                                    <span>{Data[7].options[1]}</span>
                                                                </div>
                                                            </div>
                                                            <div className="yesAnswer mb-4">
                                                                <div className="iconDiv">
                                                                    <img src={yesIcon} alt="" className='img-fluid' />
                                                                </div>
                                                                <div className="questionDiv" onClick={() => handleOnClick(7, "2021")}>
                                                                    <span>{Data[7].options[2]}</span>
                                                                </div>
                                                            </div>
                                                            <div className="yesAnswer">
                                                                <div className="iconDiv">
                                                                    <img src={NoIcon} alt="" className='img-fluid' />
                                                                </div>
                                                                <div className="questionDiv" onClick={() => handleOnClick(7, "no")}>
                                                                    <span>{Data[7].options[3]}</span>
                                                                </div>
                                                            </div>
                                                            <div className="backBtn mt-4">
                                                                <a href="#" className='btn' onClick={() => Pre(6, "", 6)}>←</a>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    //  Means Boths Yes for Q#7
                                                    Q === 8 && Data[7].answer === Data[7].options[0] ?
                                                        <div className="secondPage p-4">
                                                            {/* <h2>Calculation result</h2> */}
                                                            < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                            {/* {calculateResult()} */}
                                                        </div>
                                                        :
                                                        Q === 9 && (Data[8].answer === Data[8].options[0] || Data[8].answer === Data[8].options[1]) ?
                                                            <div className="secondPage p-4">
                                                                {/* <h2>Calculation result</h2> */}
                                                                < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                                {/* {calculateResult()} */}
                                                            </div>
                                                            :
                                                            //  Q#7 => 2020
                                                            Q === 8 && Data[7].answer === Data[7].options[1] ? <>
                                                                <h2>{Data[11].q}</h2>
                                                                <div className="parentDiv">
                                                                    <div className="yesAnswer mb-4">
                                                                        <div className="iconDiv">
                                                                            <img src={yesIcon} alt="" className='img-fluid' />
                                                                        </div>
                                                                        <div className="questionDiv" onClick={() => handleOnClick(11, "yes")}>
                                                                            <span>{Data[11].options[0]}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="yesAnswer mb-4">
                                                                        <div className="iconDiv">
                                                                            <img src={yesIcon} alt="" className='img-fluid' />
                                                                        </div>
                                                                        <div className="questionDiv" onClick={() => handleOnClick(11, "no")}>
                                                                            <span>{Data[11].options[1]}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="backBtn mt-4">
                                                                        <a href="#" className='btn' onClick={() => Pre(7, "", 7)}>←</a>
                                                                    </div>

                                                                </div>
                                                            </>
                                                                :
                                                                //  Q#7 => 2021
                                                                Q === 8 && Data[7].answer === Data[7].options[2] ? <>
                                                                    <h2>{Data[9].q}</h2>
                                                                    <div className="parentDiv">
                                                                        <div className="yesAnswer mb-4">
                                                                            <div className="iconDiv">
                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                            </div>
                                                                            <div className="questionDiv" onClick={() => handleOnClick(9, "yes")}>
                                                                                <span>{Data[9].options[0]}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="yesAnswer mb-4">
                                                                            <div className="iconDiv">
                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                            </div>
                                                                            <div className="questionDiv" onClick={() => handleOnClick(9, "no")}>
                                                                                <span>{Data[9].options[1]}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="backBtn mt-4">
                                                                            <a href="#" className='btn' onClick={() => Pre(7, "", 7)}>←</a>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                    :
                                                                    //  Q#7 => No
                                                                    Q === 8 && Data[7].answer === Data[7].options[3] ? <>
                                                                        <div className="secondPage p-4">
                                                                            <h2>You Do Not Qualify for ERC</h2>
                                                                            <p>Unfortunately based on your answers, it appears that you do not qualify for the Employee Retention Tax Credit program.</p>
                                                                        </div>
                                                                    </>
                                                                        :
                                                                        //  Means 50% => No, 20% => Yes
                                                                        Q === 7 && Data[5].answer === Data[5].options[1] && Data[6].answer === Data[6].options[0] ?
                                                                            // 12
                                                                            <>
                                                                                <h2>{Data[12].q}</h2>
                                                                                <div className="parentDiv">
                                                                                    <div className="yesAnswer mb-4">
                                                                                        <div className="iconDiv">
                                                                                            <img src={yesIcon} alt="" className='img-fluid' />
                                                                                        </div>
                                                                                        <div className="questionDiv" onClick={() => handleOnClick(12, "yes")}>
                                                                                            <span>{Data[12].options[0]}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="yesAnswer mb-4">
                                                                                        <div className="iconDiv">
                                                                                            <img src={yesIcon} alt="" className='img-fluid' />
                                                                                        </div>
                                                                                        <div className="questionDiv" onClick={() => handleOnClick(12, "no")}>
                                                                                            <span>{Data[12].options[1]}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="backBtn mt-4">
                                                                                        <a href="#" className='btn' onClick={() => Pre(6, "", 6)}>←</a>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                            :
                                                                            //  Means 50% => Yes, 20% => No
                                                                            Q === 7 && Data[5].answer === Data[5].options[0] && Data[6].answer === Data[6].options[1] ?
                                                                                // 12
                                                                                <>
                                                                                    <h2>{Data[10].q}</h2>
                                                                                    <div className="parentDiv">
                                                                                        <div className="yesAnswer mb-4">
                                                                                            <div className="iconDiv">
                                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                                            </div>
                                                                                            <div className="questionDiv" onClick={() => handleOnClick(10, "yes")}>
                                                                                                <span>{Data[10].options[0]}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="yesAnswer mb-4">
                                                                                            <div className="iconDiv">
                                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                                            </div>
                                                                                            <div className="questionDiv" onClick={() => handleOnClick(10, "no")}>
                                                                                                <span>{Data[10].options[1]}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="backBtn mt-4">
                                                                                            <a href="#" className='btn' onClick={() => Pre(6, "", 6)}>←</a>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                                :                                              ///---------------------After myone--------------------///

                                                                                Q === 14 ? <>
                                                                                    <h2>{Data[14].q}</h2>
                                                                                    <div className="parentDiv">
                                                                                        <div className="yesAnswer mb-4">
                                                                                            <div className="iconDiv">
                                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                                            </div>
                                                                                            <div className="questionDiv" onClick={() => handleOnClick(14, "yes")}>
                                                                                                <span>{Data[14].options[0]}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="yesAnswer">
                                                                                            <div className="iconDiv">
                                                                                                <img src={NoIcon} alt="" className='img-fluid' />
                                                                                            </div>
                                                                                            <div className="questionDiv" onClick={() => handleOnClick(14, "no")}>
                                                                                                <span>{Data[14].options[1]}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="backBtn mt-4">
                                                                                            <a href="#" className='btn' onClick={() => Pre(7, "", 7)}>←</a>
                                                                                        </div>
                                                                                        {/* <div className="contBtn mt-4">
                                                                                        <a href="#" className='btn'>Continue →</a>
                                                                                    </div> */}
                                                                                    </div>

                                                                                </>
                                                                                    :
                                                                                    (Q === 15 && Data[14].answer === Data[14].options[0]) ? <>
                                                                                        <div className="secondPage p-4">
                                                                                            <h2>You Do Not Qualify for ERC</h2>
                                                                                            <p>Unfortunately based on your answers, it appears that you do not qualify for the Employee Retention Tax Credit program.</p>
                                                                                        </div>
                                                                                    </>
                                                                                        :
                                                                                        Q === 15 ? <>
                                                                                            <h2>{Data[15].q}</h2>
                                                                                            <div className="parentDiv">
                                                                                                <div className="yesAnswer mb-4">
                                                                                                    <div className="iconDiv">
                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                    </div>
                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(15, "yes")}>
                                                                                                        <span>{Data[15].options[0]}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="yesAnswer">
                                                                                                    <div className="iconDiv">
                                                                                                        <img src={NoIcon} alt="" className='img-fluid' />
                                                                                                    </div>
                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(15, "no")}>
                                                                                                        <span>{Data[15].options[1]}</span>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="backBtn mt-4">
                                                                                                    <a href="#" className='btn' onClick={() => Pre(14, "", 14)}>←</a>
                                                                                                </div>
                                                                                                {/* <div className="contBtn mt-4">
                                                                                    <a href="#" className='btn'>Continue →</a>
                                                                                </div> */}
                                                                                            </div>

                                                                                        </>
                                                                                            :
                                                                                            Q === 16 ? <>
                                                                                                <h2>{Data[16].q}</h2>
                                                                                                <div className="parentDiv">
                                                                                                    <div className="yesAnswer mb-4">
                                                                                                        <div className="iconDiv">
                                                                                                            <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                        </div>
                                                                                                        <div className="questionDiv" onClick={() => handleOnClick(16, "yes")}>
                                                                                                            <span>{Data[16].options[0]}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="yesAnswer">
                                                                                                        <div className="iconDiv">
                                                                                                            <img src={NoIcon} alt="" className='img-fluid' />
                                                                                                        </div>
                                                                                                        <div className="questionDiv" onClick={() => handleOnClick(16, "no")}>
                                                                                                            <span>{Data[16].options[1]}</span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="backBtn mt-4">
                                                                                                        <a href="#" className='btn' onClick={() => Pre(15, "", 15)}>←</a>
                                                                                                    </div>

                                                                                                    {/* <div className="contBtn mt-4">
                                                                                       <a href="#" className='btn'>Continue →</a>
                                                                                     </div> */}
                                                                                                </div>

                                                                                            </>
                                                                                                :
                                                                                                //  Means Boths Yes
                                                                                                Q === 17 && Data[15].answer === Data[15].options[0] && Data[16].answer === Data[6].options[0] ?
                                                                                                    <div className="secondPage p-4">
                                                                                                        {/* <h2>Calculation result</h2> */}
                                                                                                        < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                                                                        {/* {calculateResult()} */}
                                                                                                    </div>
                                                                                                    :

                                                                                                    //  Means Boths No
                                                                                                    Q === 17 && Data[15].answer === Data[15].options[1] && Data[16].answer === Data[16].options[1] ?
                                                                                                        <>
                                                                                                            <h2>{Data[17].q}</h2>
                                                                                                            <div className="parentDiv">
                                                                                                                <div className="yesAnswer mb-4">
                                                                                                                    <div className="iconDiv">
                                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                    </div>
                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(17, "yes")}>
                                                                                                                        <span>{Data[17].options[0]}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="yesAnswer mb-4">
                                                                                                                    <div className="iconDiv">
                                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                    </div>
                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(17, "2020")}>
                                                                                                                        <span>{Data[7].options[1]}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="yesAnswer mb-4">
                                                                                                                    <div className="iconDiv">
                                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                    </div>
                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(17, "2021")}>
                                                                                                                        <span>{Data[7].options[2]}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="yesAnswer">
                                                                                                                    <div className="iconDiv">
                                                                                                                        <img src={NoIcon} alt="" className='img-fluid' />
                                                                                                                    </div>
                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(17, "no")}>
                                                                                                                        <span>{Data[7].options[3]}</span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="backBtn mt-4">
                                                                                                                    <a href="#" className='btn' onClick={() => Pre(16, "", 16)}>←</a>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </>
                                                                                                        :
                                                                                                        //  Means Boths Yes for Q#7
                                                                                                        Q === 18 && Data[17].answer === Data[17].options[0] ?
                                                                                                            <div className="secondPage p-4">
                                                                                                                {/* <h2>Calculation result</h2> */}
                                                                                                                < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                                                                                {/* {calculateResult()} */}
                                                                                                            </div>

                                                                                                            :
                                                                                                            //  Means Boths No
                                                                                                            Q === 17 && Data[15].answer === Data[15].options[1] && Data[16].answer === Data[16].options[1] ||
                                                                                                                Q === 17 && Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[1] ?
                                                                                                                <>
                                                                                                                    <h2>{Data[17].q}</h2>
                                                                                                                    <div className="parentDiv">
                                                                                                                        <div className="yesAnswer mb-4">
                                                                                                                            <div className="iconDiv">
                                                                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                            </div>
                                                                                                                            <div className="questionDiv" onClick={() => handleOnClick(17, "yes")}>
                                                                                                                                <span>{Data[17].options[0]}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div className="yesAnswer mb-4">
                                                                                                                            <div className="iconDiv">
                                                                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                            </div>
                                                                                                                            <div className="questionDiv" onClick={() => handleOnClick(17, "2020")}>
                                                                                                                                <span>{Data[17].options[1]}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div className="yesAnswer mb-4">
                                                                                                                            <div className="iconDiv">
                                                                                                                                <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                            </div>
                                                                                                                            <div className="questionDiv" onClick={() => handleOnClick(17, "2021")}>
                                                                                                                                <span>{Data[17].options[2]}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div className="yesAnswer">
                                                                                                                            <div className="iconDiv">
                                                                                                                                <img src={NoIcon} alt="" className='img-fluid' />
                                                                                                                            </div>
                                                                                                                            <div className="questionDiv" onClick={() => handleOnClick(17, "no")}>
                                                                                                                                <span>{Data[17].options[3]}</span>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div className="backBtn mt-4">
                                                                                                                            <a href="#" className='btn' onClick={() => Pre(15, "", 15)}>←</a>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </>
                                                                                                                :
                                                                                                                //  Means Boths Yes for Q#17
                                                                                                                Q === 18 && Data[17].answer === Data[17].options[0] ?
                                                                                                                    <div className="secondPage p-4">
                                                                                                                        {/* <h2>Calculation result</h2> */}
                                                                                                                        < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                                                                                        {/* {calculateResult()} */}
                                                                                                                    </div>
                                                                                                                    :
                                                                                                                    Q === 19 && (Data[18].answer === Data[18].options[0] || Data[18].answer === Data[18].options[1]) ?
                                                                                                                        <div className="secondPage p-4">
                                                                                                                            {/* <h2>Calculation result</h2> */}
                                                                                                                            < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                                                                                            {/* {calculateResult()} */}
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        //  Q#17 => 2020
                                                                                                                        Q === 18 && Data[17].answer === Data[17].options[1] ? <>
                                                                                                                            <h2>{Data[22].q}</h2>
                                                                                                                            <div className="parentDiv">
                                                                                                                                <div className="yesAnswer mb-4">
                                                                                                                                    <div className="iconDiv">
                                                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                    </div>
                                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(22, "yes")}>
                                                                                                                                        <span>{Data[22].options[0]}</span>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                                <div className="yesAnswer mb-4">
                                                                                                                                    <div className="iconDiv">
                                                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                    </div>
                                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(22, "no")}>
                                                                                                                                        <span>{Data[22].options[1]}</span>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                                <div className="backBtn mt-4">
                                                                                                                                    <a href="#" className='btn' onClick={() => Pre(17, "", 17)}>←</a>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </>
                                                                                                                            :
                                                                                                                            //  Q#17 => 2021
                                                                                                                            Q === 18 && Data[17].answer === Data[17].options[2] ? <>
                                                                                                                                <h2>{Data[19].q}</h2>
                                                                                                                                <div className="parentDiv">
                                                                                                                                    <div className="yesAnswer mb-4">
                                                                                                                                        <div className="iconDiv">
                                                                                                                                            <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                        </div>
                                                                                                                                        <div className="questionDiv" onClick={() => handleOnClick(19, "yes")}>
                                                                                                                                            <span>{Data[19].options[0]}</span>
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                    <div className="yesAnswer mb-4">
                                                                                                                                        <div className="iconDiv">
                                                                                                                                            <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                        </div>
                                                                                                                                        <div className="questionDiv" onClick={() => handleOnClick(19, "no")}>
                                                                                                                                            <span>{Data[19].options[1]}</span>
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                    <div className="backBtn mt-4">
                                                                                                                                        <a href="#" className='btn' onClick={() => Pre(17, "", 17)}>←</a>
                                                                                                                                    </div>
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                                :
                                                                                                                                //  Q#17 => No
                                                                                                                                Q === 18 && Data[17].answer === Data[17].options[3] ? <>
                                                                                                                                    <div className="secondPage p-4">
                                                                                                                                        <h2>You Do Not Qualify for ERC</h2>
                                                                                                                                        <p>Unfortunately based on your answers, it appears that you do not qualify for the Employee Retention Tax Credit program.</p>
                                                                                                                                    </div>
                                                                                                                                </>
                                                                                                                                    :
                                                                                                                                    //  Means 50% => No, 20% => Yes
                                                                                                                                    Q === 17 && Data[15].answer === Data[15].options[1] && Data[16].answer === Data[16].options[0] ?
                                                                                                                                        // 12
                                                                                                                                        <>
                                                                                                                                            <h2>{Data[22].q}</h2>
                                                                                                                                            <div className="parentDiv">
                                                                                                                                                <div className="yesAnswer mb-4">
                                                                                                                                                    <div className="iconDiv">
                                                                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                                    </div>
                                                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(22, "yes")}>
                                                                                                                                                        <span>{Data[22].options[0]}</span>
                                                                                                                                                    </div>
                                                                                                                                                </div>
                                                                                                                                                <div className="yesAnswer mb-4">
                                                                                                                                                    <div className="iconDiv">
                                                                                                                                                        <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                                    </div>
                                                                                                                                                    <div className="questionDiv" onClick={() => handleOnClick(22, "no")}>
                                                                                                                                                        <span>{Data[22].options[1]}</span>
                                                                                                                                                    </div>
                                                                                                                                                </div>
                                                                                                                                                <div className="backBtn mt-4">
                                                                                                                                                    <a href="#" className='btn' onClick={() => Pre(16, "", 16)}>←</a>
                                                                                                                                                </div>
                                                                                                                                            </div>
                                                                                                                                        </>
                                                                                                                                        // :
                                                                                                                                        // //  Means ppp => Yes, 20% => No
                                                                                                                                        // Q === 17 && Data[15].answer === Data[15].options[0] && Data[16].answer === Data[16].options[1] ?
                                                                                                                                        // 12
                                                                                                                                        // <>
                                                                                                                                        //     <h2>{Data[20].q}</h2>
                                                                                                                                        //     <div className="parentDiv">
                                                                                                                                        //         <div className="yesAnswer mb-4">
                                                                                                                                        //             <div className="iconDiv">
                                                                                                                                        //                 <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                        //             </div>
                                                                                                                                        //             <div className="questionDiv" onClick={() => handleOnClick(20, "yes")}>
                                                                                                                                        //                 <span>{Data[20].options[0]}</span>
                                                                                                                                        //             </div>
                                                                                                                                        //         </div>
                                                                                                                                        //         <div className="yesAnswer mb-4">
                                                                                                                                        //             <div className="iconDiv">
                                                                                                                                        //                 <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                        //             </div>
                                                                                                                                        //             <div className="questionDiv" onClick={() => handleOnClick(20, "2020")}>
                                                                                                                                        //                 <span>{Data[20].options[1]}</span>
                                                                                                                                        //             </div>
                                                                                                                                        //         </div>
                                                                                                                                        //         <div className="yesAnswer mb-4">
                                                                                                                                        //             <div className="iconDiv">
                                                                                                                                        //                 <img src={yesIcon} alt="" className='img-fluid' />
                                                                                                                                        //             </div>
                                                                                                                                        //             <div className="questionDiv" onClick={() => handleOnClick(20, "2021")}>
                                                                                                                                        //                 <span>{Data[20].options[2]}</span>
                                                                                                                                        //             </div>
                                                                                                                                        //         </div>
                                                                                                                                        //         <div className="yesAnswer">
                                                                                                                                        //             <div className="iconDiv">
                                                                                                                                        //                 <img src={NoIcon} alt="" className='img-fluid' />
                                                                                                                                        //             </div>
                                                                                                                                        //             <div className="questionDiv" onClick={() => handleOnClick(20, "no")}>
                                                                                                                                        //                 <span>{Data[20].options[3]}</span>
                                                                                                                                        //             </div>
                                                                                                                                        //         </div>
                                                                                                                                        //     </div>
                                                                                                                                        // </>
                                                                                                                                        :

                                                                                                                                        ///---------------------After myone--------------------///
                                                                                                                                        (
                                                                                                                                            (Q === 9 && (Data[11].answer === Data[11].options[0] || Data[11].answer === Data[11].options[1]))
                                                                                                                                            ||
                                                                                                                                            (Q === 9 && (Data[7].answer === Data[7].options[2]))
                                                                                                                                            ||
                                                                                                                                            (Data[12].answer === Data[12].options[0] || Data[12].answer === Data[12].options[1])
                                                                                                                                            ||
                                                                                                                                            (Data[10].answer === Data[10].options[0] || Data[10].answer === Data[10].options[1])
                                                                                                                                            ||
                                                                                                                                            (Q === 19 && (Data[21].answer === Data[21].options[0] || Data[21].answer === Data[21].options[1]))
                                                                                                                                            ||
                                                                                                                                            (Q === 19 && (Data[17].answer === Data[17].options[2]))
                                                                                                                                            ||
                                                                                                                                            (Data[22].answer === Data[22].options[0] || Data[22].answer === Data[22].options[1])
                                                                                                                                            ||
                                                                                                                                            (Data[20].answer === Data[20].options[0] || Data[20].answer === Data[20].options[1])
                                                                                                                                        ) ?
                                                                                                                                            <div className="secondPage p-4">
                                                                                                                                                {/* <h2>Calculation result</h2> */}
                                                                                                                                                < ENDING calculateResult={calculateResult} SetProgress={setProgress} Progress={Progress} />
                                                                                                                                                {/* // {calculateResult()} */}
                                                                                                                                            </div>
                                                                                                                                            :
                                                                                                                                            <div className="secondPage p-4">
                                                                                                                                                <h2>You Do Not Qualify for ERC</h2>
                                                                                                                                                <p>Unfortunately based on your answers, it appears that you do not qualify for the Employee Retention Tax Credit program.</p>
                                                                                                                                            </div>

                }




                {/* <hr />
                <hr />
                <hr />
                <hr />
                <h2>Did you pay any W2 Wages <br /> in 2020 or 2021?</h2>
                <div className="panel-body">
                    <div className="panel-content">
                        <img src={iconArrowLeft} alt="" className='img-fluid iconLeft' />
                        <em>Please select one</em>
                        <img src={iconArrowRight} alt="" className='img-fluid iconRight' />
                    </div>
                </div>

                <div className="parentDiv">
                    <div className="yesAnswer mb-4">
                        <div className="iconDiv">
                            <img src={yesIcon} alt="" className='img-fluid' />
                        </div>
                        <div className="questionDiv">
                            <span>Yes, I Paid W2 Wages</span>
                        </div>
                    </div>
                    <div className="yesAnswer">
                        <div className="iconDiv">
                            <img src={NoIcon} alt="" className='img-fluid' />
                        </div>
                        <div className="questionDiv">
                            <span>No, I Did Not...</span>
                        </div>
                    </div>
                    <div className="contBtn mt-4">
                        <a href="#" className='btn'>Continue →</a>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="secondPage p-4">
                    <h2>Roughly, how many Full Time W2 Employees did you have on average during 2020?</h2>
                    <form>
                        <input type="number" className="form-control" placeholder='20' />
                    </form>
                    <div className="backBtn">
                        <a href="#" className='btn'>←</a>
                    </div>
                    <div className="contBtn">
                        <a href="#" className='btn'>Continue →</a>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="thirdPage">
                    <h2>Did you start your business before or after Feb 15, 2020?</h2>
                    <div className="parentDiv">
                        <div className="yesAnswer mb-4">
                            <div className="iconDiv">
                                <img src={IconCalBefore} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>I Started Before Feb 15, 2020</span>
                            </div>
                        </div>
                        <div className="yesAnswer">
                            <div className="iconDiv">
                                <img src={IconCalAfter} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>I Started After Feb 15, 2020</span>
                            </div>
                        </div>
                        <div className="backBtn mt-4">
                            <a href="#" className='btn'>←</a>
                        </div>
                        <div className="contBtn">
                            <a href="#" className='btn'>Continue →</a>
                        </div>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="fourthPage">
                    <h2>Did your business generate over $1 million in gross revenue in 2020?</h2>
                    <div className="parentDiv">
                        <div className="yesAnswer mb-4">
                            <div className="iconDiv">
                                <img src={yesIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>Yes, It Earned Over $1 Million</span>
                            </div>
                        </div>
                        <div className="yesAnswer">
                            <div className="iconDiv">
                                <img src={NoIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>No, It Did Not...</span>
                            </div>
                        </div>
                        <div className="backBtn mt-4">
                            <a href="#" className='btn'>←</a>
                        </div>
                        <div className="contBtn">
                            <a href="#" className='btn'>Continue →</a>
                        </div>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="fifthPage">
                    <h2>Did you get a PPP loan in 2020 or 2021?</h2>
                    <div className="parentDiv">
                        <div className="yesAnswer mb-4">
                            <div className="iconDiv">
                                <img src={yesIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>Yes, I Got a PPP Loan</span>
                            </div>
                        </div>
                        <div className="yesAnswer">
                            <div className="iconDiv">
                                <img src={NoIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>No, I Did Not...</span>
                            </div>
                        </div>
                        <div className="backBtn mt-4">
                            <a href="#" className='btn'>←</a>
                        </div>
                        <div className="contBtn">
                            <a href="#" className='btn'>Continue →</a>
                        </div>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="sixPage">
                    <h2>Did you have a decrease in revenue of at least 20% in any quarter in 2021 compared to 2019?</h2>
                    <div className="parentDiv">
                        <div className="yesAnswer mb-4">
                            <div className="iconDiv">
                                <img src={yesIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>Yes, We Had a +20% Decrease</span>
                            </div>
                        </div>
                        <div className="yesAnswer">
                            <div className="iconDiv">
                                <img src={NoIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>No, I Did Not...</span>
                            </div>
                        </div>
                        <div className="backBtn mt-4">
                            <a href="#" className='btn'>←</a>
                        </div>
                        <div className="contBtn">
                            <a href="#" className='btn'>Continue →</a>
                        </div>
                    </div>

                </div>

                <br />
                <br />
                <br />

                <div className="sevenPage">
                    <h2>Did you experience any partial or full suspensions of business due to a COVID Government Order in 2020 or 2021?</h2>
                    <div className="parentDiv">
                        <div className="yesAnswer mb-4">
                            <div className="iconDiv">
                                <img src={yesIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>Yes, in Both Years</span>
                            </div>
                        </div>
                        <div className="yesAnswer mb-4">
                            <div className="iconDiv">
                                <img src={IconMayBe} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>Yes, But Only in 2020</span>
                            </div>
                        </div>
                        <div className="yesAnswer mb-4">
                            <div className="iconDiv">
                                <img src={IconMayBe} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>Yes, But Only in 2021</span>
                            </div>
                        </div>
                        <div className="yesAnswer">
                            <div className="iconDiv">
                                <img src={NoIcon} alt="" className='img-fluid' />
                            </div>
                            <div className="questionDiv">
                                <span>No...</span>
                            </div>
                        </div>
                        <div className="backBtn mt-4">
                            <a href="#" className='btn'>←</a>
                        </div>
                        <div className="contBtn">
                            <a href="#" className='btn'>Continue →</a>
                        </div>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="eightPage p-3">
                    <h2>Congratulations! It looks like you most likely qualify for an ERC Credit! To give your estimate credit amount, we first need your name?</h2>
                    <form>
                        <input type="text" className='form-control mb-3' placeholder='First Name' />
                        <input type="text" className='form-control' placeholder='Last Name' />
                    </form>
                    <div className="backBtn mt-4">
                        <a href="#" className='btn'>←</a>
                    </div>
                    <div className="contBtn">
                        <a href="#" className='btn'>Continue →</a>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="ninePage p-3">
                    <h2>Thank you n, now what email address should we send your results to?</h2>
                    <form>
                        <input type="email" className='form-control' placeholder='Enter Email Address' />
                    </form>
                    <div className="backBtn mt-4">
                        <a href="#" className='btn'>←</a>
                    </div>
                    <div className="contBtn">
                        <a href="#" className='btn'>Continue →</a>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="tenPage p-3">
                    <h2>Thank you n. Now what is the name of the business applying?</h2>
                    <form>
                        <input type="text" className='form-control' placeholder='Business Name...' />
                    </form>
                    <div className="backBtn mt-4">
                        <a href="#" className='btn'>←</a>
                    </div>
                    <div className="contBtn">
                        <a href="#" className='btn'>Continue →</a>
                    </div>
                </div>

                <br />
                <br />
                <br />

                <div className="elevenPage p-3">
                    <h2>Great n, now what is the best phone number to reach you at?</h2>
                    <form>
                        <input type="tel" className='form-control' placeholder='0301 23451678' />
                    </form>
                    <div className="backBtn mt-4">
                        <a href="#" className='btn'>←</a>
                    </div>
                    <div className="contBtn">
                        <a href="#" className='btn'>Continue →</a>
                    </div>
                </div>

                <br />
                <br />
                <br /> */}

                {/* Page If Not Qualify */}

                {/* <h2>You Do Not Qualify for ERC</h2>
                <p>Unfortunately based on your answers, it appears that you do not qualify for the Employee Retention Tax Credit program.</p> */}

                {/* <iframe
                    className='quizForm'
                    height="100%"
                    id="quiz-iframe-39SFMnQX79kG0gaZtWMlOyr4iUWHB9xyNQszuB1D"
                    width="100%"
                    allowFullScreen="true"
                    frameBorder="0"
                    border="none"
                    scrolling="no"
                    style={{ width: "100%", minWidth: "100%" }}
                    data-offset="0" data-autoscroll="no"
                    src="https://18leads.leadshook.io/survey/39SFMnQX79kG0gaZtWMlOyr4iUWHB9xyNQszuB1D?embed=true&amp;index=0#clickid%3D63cac72d3bc21e00014f7fc3"
                    data-gtm-yt-inspected-15="true"
                >
                </iframe> */}
                <div className="secure-banner">
                    <img src={lockImg} alt="" className='img-fluid' />
                    &nbsp; 256-bit Secure Encryption
                </div>

            </div>
        </>
    )
}


function ENDING(props) {
    const navigate = useNavigate()

    const [show, setShow] = useState("");
    const [name, setName] = useState("")
    const [name1, setName1] = useState(false)
    const [lname, setLName] = useState("")
    const [lname1, setLName1] = useState(false)

    const [showE, setShowE] = useState(false);
    const [E, setE] = useState("")
    const [EValid, setEValid] = useState(false)

    const [showB, setShowB] = useState(false);
    const [BName, setBName] = useState("");
    const [BValid, setBValid] = useState(false)

    const [CName, setCName] = useState("1");
    const [CValid, setCValid] = useState(false);

    const quizData = []
    data.forEach((item, i) => {
        // because on zero index we set undefined data
        if (i !== 0) {
            quizData.push({
                question: item.q,
                answer: item.answer
            })
        }
    });

    async function submit() {
        const myForm = {
            firstName: name,
            lastName: lname,
            email: E,
            businessName: BName,
            phone: CName,
            quiz: quizData,
            amount: localStorage.getItem("amount"),
            createdAt: serverTimestamp()
        }
        // console.log(myForm);

        // await addDoc(collection(db, "quiz"), myForm)  // working
        await setDoc(doc(db, "quiz", (Date.now()).toString()), myForm)
            .then(data => {
                sendEmail({
                    name: name,
                    email: E,
                })
                //   console.log(data);
                //   alert("Quiz submitted")
            })
            .catch(err => {
                console.log(err);
            })
    }

    useEffect(() => {
        props.SetProgress(69.24)
        setTimeout(() => {
            setShow("name")
        }, 2000);
    }, [])


    function asdewqe() {
        let NPro = parseFloat(props.Progress) + 7.69

        if (show === "name") {

            if (name === "") {
                setName1(true)
            } else {
                setName1(false)
            }

            if (lname === "") {
                setLName1(true)
            } else {
                setLName1(false)
            }

            if (name !== "" && lname !== "") {
                props.SetProgress(NPro)
                setShow("email")

            }

        } else if (show === "email") {
            if (EmailValidator.validate(E)) {
                props.SetProgress(NPro)
                setShow("bname")
            } else {
                setEValid(true)
            }

        } else if (show === "bname") {
            if (BName === "") {
                setBValid(true)
            } else {
                props.SetProgress(NPro)
                setShow("cname")
            }

        } else if (show === "cname") {
            if (CName.length !== 11) {
                setCValid(true)
            } else {
                props.SetProgress(NPro)
                props.calculateResult()
                setShow("-----")
                submit()
            }
        }
    }

    return <>
        {
            show === "" ?
                <p>Checking Qualification</p>
                :
                show === "name" ?
                    <div>
                        <div className="secondPage">
                            <h2>Congratulations! It looks like you most likely qualify for an ERC Credit! To give your estimate credit amount, we first need your name?</h2>
                            <form className="mb-2" onSubmit={(e) => e.preventDefault()} style={{ position: "relative" }}>
                                <input type="text" value={name} className="form-control mb-3 p-3" placeholder='First Name' onChange={(e) => { setName(e.target.value); localStorage.setItem("name", e.target.value) }} />
                                {name1 === true && <ERRORMSG msg={"This field is required."} />}
                            </form>

                            <form className="mb-2" onSubmit={(e) => e.preventDefault()} style={{ position: "relative" }}>
                                <input type="text" className="form-control mb-3 p-3" placeholder='Last Name' value={lname} onChange={(e) => { setLName(e.target.value) }} />
                                {lname1 === true && <ERRORMSG msg={"This field is required."} />}
                            </form>

                            <div className="row formBTNs">
                                <div className="col-3 backBtn">
                                    <a href="#" className='btn'>←</a>
                                </div>
                                <div className="col-9 contBtn">
                                    <a href="#" className='btn' onClick={() => { asdewqe() }}>Continue →</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    show === "email" ?
                        <div>
                            <div className="secondPage p-4">
                                <h2>Thank you no, now what email address should we send your results to?</h2>
                                <form className="mb-2" onSubmit={(e) => e.preventDefault()} style={{ position: "relative" }}>
                                    <input value={E} onChange={(e) => setE(e.target.value)} type="email" className="form-control mb-3 p-3" placeholder='Enter Email Address' />
                                    {EValid && <ERRORMSG msg={"Email is invalid"} />}
                                </form>
                                <div className="row formBTNs">
                                    <div className="col-3 backBtn">
                                        <a href="#" className='btn'>←</a>
                                    </div>
                                    <div className="col-9 contBtn">
                                        <a href="#" className='btn' onClick={() => { asdewqe() }}>Continue →</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        show === "bname" ?
                            <div>
                                <div className="secondPage p-4">
                                    <h2>Thank you no. Now what is the name of the business applying?</h2>
                                    <form className="mb-2" onSubmit={(e) => e.preventDefault()} style={{ position: "relative" }}>
                                        <input type="text" value={BName} onChange={(e) => setBName(e.target.value)} className="form-control mb-3 p-3" placeholder='Business Name' />
                                        {BValid && <ERRORMSG msg={"This filed is required."} />}
                                    </form>
                                    <div className="row formBTNs">
                                        <div className="col-3 backBtn">
                                            <a href="#" className='btn'>←</a>
                                        </div>
                                        <div className="col-9 contBtn">
                                            <a href="#" className='btn' onClick={() => { asdewqe() }}>Continue →</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            show === "cname" ?
                                <div>
                                    <div className="secondPage p-4">
                                        <h2>Great ali, now what is the best phone number to reach you at?</h2>
                                        <form className="mb-2" onSubmit={(e) => e.preventDefault()} style={{ position: "relative" }}>
                                            {/* <input type="text" value={CName} onChange={(e) => setCName(e.target.value)} className="form-control" placeholder='Phone Name' /> */}
                                            <PhoneInput country={"us"} enableSearch={true} value={CName} onChange={(phone) => setCName(phone)} />
                                            {CValid && <ERRORMSG msg={"Invalid phone number"} />}
                                        </form>
                                        <div className="row formBTNs">
                                            <div className="col-3 backBtn">
                                                <a href="#" className='btn'>←</a>
                                            </div>
                                            <div className="col-9 contBtn">
                                                <a href="#" className='btn' onClick={() => { asdewqe() }}>Continue →</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <> {/* <h1>uuu</h1> */} </>
        }
    </>
}

export default FormCard